module.exports = __webpack_public_path__ + "media/src/pages/Onboarding/images/airplane-inside-2bb3dcb0a22d4fec48fad62af65d4dbc.png";